import { api } from "../../api";

export const loadFields = async (state, setState, id) => {
  const { data } = await api
    .get("register/event/" + id)
    .catch((error) => error.response);

  const { payload, ...event } = data.payload;

  payload.forEach((f) => {
    if (f.name === "interesting") {
      f.list.push({ masterid: 999999, mastername: "" });
    }
  });

  const fields = payload.filter((v) => !!v.display);

  setState({
    ...state,
    event,
    form: fields.map((f) => ({
      ...f,
      value: f.type === "date" ? null : "",
      label:
        f.question_label !== "" && /^question.*/g.test(f.name)
          ? f.question_label
          : f.label,
      placeholder:
        f.question_label !== "" && /^question.*/g.test(f.name)
          ? f.question_label
          : f.placeholder,
    })),
    open: false,
  });
  window.scrollTo(0, 0);
};

export const save = async (state, setState, values, navigate) => {
  const formData = new FormData();

  for (const key in values) {
    if (Object.hasOwnProperty.call(values, key)) {
      const element = values[key];
      formData.append(key, element);
    }
  }

  formData.append("assetId", state.event.assetId);
  formData.append(
    "params_url",
    window.localStorage.getItem("utm") || window.location.search
  );

  try {
    const { data } = await api
      .post("register", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => error.response);

    if (data.result) {
      window.localStorage.removeItem("utm");
      setState({ ...state, open: false });
      navigate(`/register/${state.event.assetId}/complete`);
    } else {
      setState({
        ...state,
        snack: true,
        open: false,
        snackMsg:
          data.error.message || "ไม่สามารถบันทึกข้อมูลได้กรุณาลองใหม่อีกครั้ง",
      });
    }
  } catch (error) {
    setState({
      ...state,
      snack: true,
      open: false,
      snackMsg: "ไม่สามารถบันทึกข้อมูลได้กรุณาลองใหม่อีกครั้ง",
    });
  }
};
